import { ClickButtonInstruction } from '../ClickButtonInstruction'

export class ClickSaveAddressInstruction extends ClickButtonInstruction {
  constructor ({ waitForNoLoaders }) {
    super({
      name: 'ClickSaveAddress',
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      className: 'action-save-address',
      click: true

    })
  }
}
